import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/fitness_statistics/available_years";

export class GetFitnessStatisticsYearsDistinctCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetFitnessStatisticsYearsDistinctResData> {
        var res = await this.executeCommand();
        return new GetFitnessStatisticsYearsDistinctResData(res);
    }
}

export class GetFitnessStatisticsYearsDistinctResData extends ApiGenericResponse {
    availableYears: number[];

    constructor(response: AxiosResponse) {
        super(response);
        this.availableYears = [];
        if (response.data && response.data.Payload && response.data.Payload.length > 0) {
            response.data.Payload.forEach((e) => {
                this.availableYears.push(e);
            });
        }
    }
}
